import request from '@/api/request'

/**
 * 管理端查询分页外部证书分组
 */
export const getListPage = (params) => {
  return request({
    url: 'radioweb/adm/outsideClassify/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 管理端添加分页外部证书分组
 */
export const addOutsideClassify = (data) => {
  return request({
    url: 'radioweb/adm/outsideClassify/addOutsideClassify',
    data,
    method: 'post'
  })
}
/**
 * 管理端更新分页外部证书分组
 */
export const updateOutsideClassify = (data) => {
  return request({
    url: 'radioweb/adm/outsideClassify/updateOutsideClassify',
    data,
    method: 'post'
  })
}
/**
 * 管理端删除分页外部证书分组
 */
export const delOutsideClassify = (data) => {
  return request({
    url: 'radioweb/adm/outsideClassify/delOutsideClassify',
    data,
    method: 'post'
  })
}
/**
 * 查询证书
 */
export const getListPageCertificate = (data) => {
  return request({
    url: 'radioweb/adm/outsideCertificate/getListPage',
    data,
    type: 'json',
    method: 'post'
  })
}
/**
 * 删除证书
 */
export const delOutsideCertificate = (data) => {
  return request({
    url: 'radioweb/adm/outsideCertificate/delOutsideCertificate',
    data,
    type: 'json',
    method: 'post'
  })
}
/**
 * 导出合格证书
 */
export const exportQualify = (data) => {
  return request({
    url: 'radioweb/adm/outsideCertificate/exportQualify',
    data,
    type: 'json',
    responseType: 'blob',
    method: 'post'
  })
}
/**
 * 导出结业证书
 */
export const exportGraduation = (data) => {
  return request({
    url: 'radioweb/adm/outsideCertificate/exportGraduation',
    data,
    type: 'json',
    responseType: 'blob',
    method: 'post'
  })
}
/**
 * 导入合格证书
 */
export const importQualify = (data) => {
  return request({
    url: 'radioweb/adm/outsideCertificate/importQualify',
    data,
    upload: true,
    responseType: 'blob',
    method: 'post'
  })
}
/**
 * 导入结业证书
 */
export const importGraduation = (data) => {
  return request({
    url: 'radioweb/adm/outsideCertificate/importGraduation',
    data,
    upload: true,
    responseType: 'blob',
    method: 'post'
  })
}